<template>
  <div>
    <div class="input-group">
      <label>Number of picks</label>
      <div v-if="errors.individualPicksValue">{{errors.individualPicksValue}}</div>
      <pinhigh-select
          :options="[2,3,4,5,6,7,8,9,10]"
          v-model="poolStyleConfigValue"
          ></pinhigh-select>
    </div>
    <div v-if="poolStyleConfigField && poolStyleConfigField.length">
      <a href="#" @click.prevent="resetPoolStyleConfigField" class="button boring inline small no-margin">Get the latest field</a>
    </div>
  </div>
</template>
<script>
import api from '../../api';

export default {
  name: 'IndividualPicks',
  props: {
    errors: Object
  },
  computed: {
    pool() {
      return this.$store.getters['poolForm/pool'];
    },
    poolStyleConfigValue: {
      get(){ return this.pool.pool_style_config.value; },
      set(value){ this.$store.dispatch('poolForm/setPoolStyleConfigValue', value); }
    },
    poolStyleConfigField() {
      return this.pool.pool_style_config.field;
    }
  },
  methods: {
    resetPoolStyleConfigField() {
      api.TournamentField.show({params: {id: this.pool.tournament_id}}).then(response => {
        this.$store.dispatch('poolForm/setPoolStyleConfigField', response.field);
      });
    }
  }
};
</script>
